




export const Utils = (() => {
	var obj = {};

	obj.convertToman = function (price) {
		let priceToman = '';
		if (price !== undefined && price !== null) {
			priceToman = String(price);
			if (priceToman.length >= 1) {
				priceToman = priceToman.substring(0, priceToman.length - 1);
			}
		}
		return priceToman;
	};

	obj.insertComma = function (price) {
		let priceStr = String(price);
		let priceComma = '';
		for (let i = 0; i < priceStr.length; i++) {
			if (i >= 1 && i % 3 === 0) {
				priceComma = ',' + priceComma;
			}
			priceComma = priceStr[priceStr.length - i - 1] + priceComma;
		}
		return priceComma;
	};

	obj.convertTomanComma = function (price) {
		let convertedPrice = obj.convertToman(price);
		convertedPrice = obj.insertComma(convertedPrice);
		return convertedPrice;
	};

	return obj;
})();
